import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getAgentRequests = createAsyncThunk(
  "AgentRequests/getAgentRequests",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/agent-ticket?teamId=${
          data?.teamId || ""
        }&userId=${data?.userId || ""}&status=${
          (data?.status === "open" ? "open,pending,new" : data?.status) || ""
        }&pageNumber=${data?.pageNumber || 1}&pageSize=${data?.pageSize || 20}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
